import React from "react";
import styled, { css } from "styled-components";
import { Button, Space, Upload as UploadAntd } from "antd";
import IntlMessages from "components/Message/IntlMessages";

const defaultShowUploadList = {
  showRemoveIcon: true,
  removeIcon: <i className="feather-icon icon-trash"></i>,
};

function Upload({ fileList, showFileCount, maxCount, ...props }) {
  return (
    <UploadStyled
      fileList={fileList}
      maxCount={maxCount}
      showRemoveIcon
      showUploadList={defaultShowUploadList}
      iconRender={() => <i className="feather-icon icon-link"></i>}
      {...props}
    >
      <Button className="w-100">
        <Space>
          <i className="feather-icon icon-upload"></i>
          <IntlMessages id="global.upload.document" />
          {showFileCount && maxCount && fileList?.length > 0 && (
            <span>
              {fileList?.length}/{maxCount}
            </span>
          )}
        </Space>
      </Button>
    </UploadStyled>
  );
}

export default Upload;

const UploadStyled = styled(UploadAntd)`
  .ant-upload {
    width: 100%;
    ${(props) => (props.disabled ? "filter: grayscale(0.8);" : "")}

    button {
      font-size: 14px;
      color: var(--ktb-navy-blue-main);
      border: 1px dashed var(--ktb-blue-main);
      background: var(--ktb-blue-light-3);

      i {
        color: var(--ktb-blue-main);
      }
    }
  }

  .ant-upload-list {
    margin-top: 12px;
    ${(props) =>
      props.hidden
        ? css`
            & * {
              display: none;
            }
          `
        : ""}

    .ant-upload-list-text-container {
      .ant-upload-list-item:not(.ant-upload-list-item-error) {
        .ant-upload-list-item-info {
          .ant-upload-text-icon > i,
          .ant-upload-list-item-name,
          .ant-upload-list-item-card-actions button > i {
            color: var(--ktb-blue-main);
          }
        }
      }
      .ant-upload-list-item.ant-upload-list-item-error {
        .ant-upload-list-item-info {
          .ant-upload-text-icon > i,
          .ant-upload-list-item-name,
          .ant-upload-list-item-card-actions button > i {
            color: var(--text-error);
          }
        }
      }
    }

    .ant-upload-list-item-card-actions button {
      opacity: 1 !important;
    }
  }
`;
